import React from 'react'
/*import {Link, BrowserRouter as Router} from "react-router-dom";*/
import {Link} from 'react-scroll'

function resumeheader() {    
        return (
            <header>
            <nav className="navbar navbar-expand aos-init aos-animate visible">
                <div className="header">
                                          
                        <div className="ml-auto"></div>
                        <ul className="navbar-nav items">
                            <li className="nav-item dropdown">
                                <Link className="nav-link" to="hi" spy={true} smooth={true}>Hi!</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link" to="about" spy={true} smooth={true}>About</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link" to="latest" spy={true} smooth={true}>Latest</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link" to="contact" spy={true} smooth={true}>Contact</Link>
                            </li>
                        </ul>                       
                     
                    </div>            
            </nav>
            </header> 
        )
    
}
export default resumeheader;